import axios from "axios";
import { env } from "../environment";

/**
 * Dedicated, standalone calls for the /deep-insights-chat/dev/demo persona
 * preview page. No credentials any more — the page just shows a dropdown
 * of personas and resolves whichever one is picked straight to its synthetic
 * identity; access is gated purely by the backend's ENABLE_DEV_DEMO flag
 * (see app/routers/dev_demo.py), which 404s both routes below when unset.
 */
export async function devDemoListPersonas() {
  try {
    const response = await axios.get(`${env.deepInsightsURL}/dev-demo/personas`);
    return { data: response.data, error: null };
  } catch (error) {
    return { data: null, error };
  }
}

export async function devDemoSelectPersona(persona) {
  try {
    const response = await axios.get(`${env.deepInsightsURL}/dev-demo/persona/${persona}`);
    return { data: response.data, error: null };
  } catch (error) {
    return { data: null, error };
  }
}
